import React from 'react'

export default function IcoArrow( props ) {
  return (
    <svg
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.4"
      viewBox="0 0 24 24"
      { ...props }
    >
      <path d="M5 12h14M13 6l6 6-6 6" />
    </svg>
  )
}
